import { ERROR_CODES } from './ErrorCodes'
import { GenericException, GenericExceptionError } from './GenericException'

export class RequestDeniedException extends GenericException {
  constructor(error?: GenericExceptionError) {
    super({
      ...ERROR_CODES.REQUEST_DENIED,
      ...(error || {}),
    })
  }
}
